<template>
  <div class="header__meta-menu header-meta-content">
    <div class="header-meta-content__content">
      <span
        class="header-meta-content__content--delivery"
        v-html="$t('meta.content.delivery_info.html', [deliverCost])"
      />
    </div>
    <div class="header-meta-content__content">
      <a
        :href="$t('meta.content.header.phone')"
        class="header-meta-content__phone footer__phone"
      >
        {{ $t('meta.content.header.phone.string') }}
      </a>
    </div>
    <div class="header-meta-content__content">
      <a
        :href="$t('contact.headline.url')"
        :aria-label="$t('contact.mail.link.button')"
        class="header-meta-content__mail footer__mail"
      >
        {{ $t('contact.mail.label.vue3') }}
      </a>
    </div>
    <div class="header-meta-content__content header-meta-content__slogan">
      <span
        class="header-meta-content__content--slogan"
        v-html="$t('meta.content.slogan.html')"
      />
    </div>
    <div
      v-if="false"
      class="header-meta-content__links"
    >
      <a
        :href="$t('meta.content.aboutUs.link.url')"
        class="header-meta-content__link"
      >
        {{ $t('meta.content.aboutUs.link') }}
      </a>
      <a
        :href="$t('contact.headline.url')"
        class="header-meta-content__link"
      >
        {{ $t('contact.headline') }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      deliverCost: '79,00'
    }
  },
}

</script>
